// extracted by mini-css-extract-plugin
export default {"hover-text":"CustomIcon_hover-text__IXEuL","hover-text-right":"CustomIcon_hover-text-right__1vTkA","hover-text-left":"CustomIcon_hover-text-left__PCsaQ"};